var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"slot-bg"},[_c('h1',{staticClass:"text-left ml-15 mt-2"},[_vm._v("Tukar Kado Sesi-1")]),_c('slot-panel',{ref:"slot-machine"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }